import React, { Suspense, lazy } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Auth from '../../../../Layout/Auth';
import POSLayout from '../../../../Layout/POSLayout';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components
const OrderList = lazy(() => import('../Pages/OrderList'));
const OrderView = lazy(() => import('../Pages/OrderView'));
const AddOrder = lazy(() => import('../Pages/AddOrder'));
const EditOrder = lazy(() => import('../Pages/EditOrder'));
const DigitalMenuOrders = lazy(() => import('../Pages/DigitalMenuOrders'));

// Loading component for Suspense fallback
const Loading = () => (
  <LoadingOverlay
    active={false}
    spinner={<FadeLoader color={"#36D7B7"} />}
    text="Loading..."
    styles={{
      overlay: (base) => ({
        ...base,
        background: "rgba(255, 255, 255, 0.8)",
      }),
      content: (base) => ({
        ...base,
        color: "#36D7B7",
      }),
    }}
  >
    <div style={{ height: "100vh" }}></div>
  </LoadingOverlay>
);

function OrderRoute() {
  const history = useHistory();

  return (
    <Switch>
      <Route
        exact
        path="/:lng/sales/orders"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <OrderList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <OrderList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/add"
        render={() => (
          <POSLayout history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <AddOrder history={history} />
            </Suspense>
          </POSLayout>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/edit/:slack"
        render={() => (
          <POSLayout history={history} allowedRoles={['app_admin', 'admin','staff']}>
            <Suspense fallback={<Loading />}>
              <EditOrder history={history} />
            </Suspense>
          </POSLayout>
        )}
      />
      <Route
        exact
        path="/:lng/sales/orders/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <OrderView history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/sales/digital-menu-orders"
        render={() => (
          // <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
          <POSLayout history={history} allowedRoles={['app_admin', 'admin','staff']}>
            <Suspense fallback={<Loading />}>
              <DigitalMenuOrders history={history} />
            </Suspense>
          </POSLayout>
          // </Auth>
        )}
      />
    </Switch>
  );
}

export default withNamespaces()(OrderRoute);
